import axios from 'axios';
// @ts-ignore
import { loadProgressBar } from 'axios-progress-bar';
import AuthService from '../auth.service';
import axiosInstance from './AxiosInstance';
loadProgressBar({ showSpinner: false }, axiosInstance);
var HttpRequests = /** @class */ (function () {
    function HttpRequests() {
        this.post = function (endpoint, data, config, useDefaultHttpInstance) {
            if (typeof useDefaultHttpInstance !== 'undefined' && !useDefaultHttpInstance) {
                return axios.post(endpoint, data, config);
            }
            return axiosInstance.post(endpoint, data, config);
        };
        this.put = function (endpoint, data, config) {
            return axiosInstance.put(endpoint, data, config);
        };
        this.get = function (endpoint, config, useDefaultHttpInstance) {
            if (typeof useDefaultHttpInstance !== 'undefined' && !useDefaultHttpInstance) {
                return axios.get(endpoint, config);
            }
            return axiosInstance.get(endpoint, config);
        };
        this.delete = function (endpoint, config) {
            return axiosInstance.delete(endpoint, config);
        };
        this.handleError = function (error, messageBlock, defaultMessage, history, providedError) {
            if (providedError === void 0) { providedError = ''; }
            var errorResponse = error.response;
            if (errorResponse && errorResponse.status === 401) {
                AuthService.breakSession(history);
            }
            else if (providedError) {
                messageBlock.show({ life: 5000, severity: 'error', detail: providedError });
            }
            else {
                if (errorResponse && errorResponse.data && errorResponse.data.message) {
                    messageBlock.show({ life: 5000, severity: 'error', detail: errorResponse.data.errors[0] ? errorResponse.data.errors[0] : errorResponse.data.message });
                }
                else {
                    messageBlock.show({ life: 5000, severity: 'error', detail: defaultMessage });
                }
            }
        };
    }
    return HttpRequests;
}());
export default HttpRequests;



//////////////////
// WEBPACK FOOTER
// ./src/classes/http/HttpRequests.ts
// module id = 4
// module chunks = 0